import {
  DebtorAccountHistoryWidgetAdminHandler
} from '../../_app_modules/debtor-account-history-widget/services/debtor-account-history-widget-admin-handler.service';
import {WidgetAdminHandler, WidgetAdminHandlerProvider} from './widget-admin-handler';
import {WidgetTypeId} from '@feature/widget-configs';
import {Injectable} from '@angular/core';
import {CashBalancesWidgetAdminHandler} from '@cash-balances/services/cash-balances-widget-admin-handler';
import {ArrearsWidgetAdminHandler} from '@arrears-widget/services/arrears-widget-admin-handler';
import {ContactUsWidgetAdminHandler} from '@contact-us/old_index';
import {TenancyScheduleWidgetAdminHandler} from '@feature/tenancy-schedule/old_index';
import {DefaultAdminHandler} from '@details/old_index';
import {PropertyPictureWidgetAdminHandler} from '@feature/properties/old_index';
import {DiaryWidgetAdminHandler} from '@diary/old_index';
import {CreditorAccountsWidgetAdminHandler} from '@creditor-accounts/services/creditor-account-widget-admin';
import {ManagerDetailsWidgetAdminHandler} from '@manager-details/services/manager-details-widget-admin-handler';
import {InvoiceUploadWidgetAdminHandler} from '@feature/invoice-upload/services/invoice-upload-widget-admin-handler';
import {PaymentsToYouWidgetAdminHandler} from '@feature/payments-to-you/services/payments-to-you-widget-admin-handler';
import {
  CreditorDetailsWidgetAdminHandler
} from '@feature/creditor-details/services/creditor-details-widget-admin-handler';
import {
  InvoiceStatusWidgetAdminHandler
} from '@feature/invoice-status/services/invoice-status-widget-admin-handler.service';
import {
  PmaDocumentCentreWidgetAdminHandlerService
} from '@feature/pma-document-centre/services/pma-document-centre-widget-admin-handler.service';
import {
  AdditionalInformationWidgetAdminHandler
} from '@feature/_app_modules/additional-information/services/additional-information-widget-admin-handler';
import {CallsWidgetAdminHandler} from '@feature/_app_modules/mojo-calls-widget/services/mojo-calls-admin-handler';
import {
  InvoicesAndReceiptsWidgetAdminHandler
} from '@feature/_app_modules/invoices-and-receipts-widget/services/invoices-and-receipts-widget-admin-handler.service';
import {
  RelatedContactsAdminHandler
} from '@feature/_app_modules/related-contacts/services/related-contacts-admin-handler';
import {
  BudgetVsActualWidgetAdminHandler
} from '@feature/_app_modules/budget-vs-actual/services/budget-vs-actual-admin-handler';
import { HeadLeaseScheduleWidgetAdminHandlerService } from '@feature/head-lease-schedule/services/head-lease-schedule-widget-admin-handler.service';

@Injectable({
  providedIn: 'root'
})
export class DefaultWidgetAdminHandlerProvider implements WidgetAdminHandlerProvider {

  private readonly map: Map<WidgetTypeId, WidgetAdminHandler>;

  constructor(
    cashBalances: CashBalancesWidgetAdminHandler,
    arrears: ArrearsWidgetAdminHandler,
    tenancySchedule: TenancyScheduleWidgetAdminHandler,
    contactUs: ContactUsWidgetAdminHandler,
    defaultHandler: DefaultAdminHandler,
    propertyPictures: PropertyPictureWidgetAdminHandler,
    diary: DiaryWidgetAdminHandler,
    creditorAccount: CreditorAccountsWidgetAdminHandler,
    managerDetails: ManagerDetailsWidgetAdminHandler,
    invoiceUpload: InvoiceUploadWidgetAdminHandler,
    paymentsToYouWidgetAdminHandler: PaymentsToYouWidgetAdminHandler,
    creditorDetails: CreditorDetailsWidgetAdminHandler,
    invoiceStatusWidgetAdminHandler: InvoiceStatusWidgetAdminHandler,
    pmaDocumentCentre: PmaDocumentCentreWidgetAdminHandlerService,
    additionalInformationWidgetAdminHandler: AdditionalInformationWidgetAdminHandler,
    debtorAccountHistoryHandler: DebtorAccountHistoryWidgetAdminHandler,
    callsWidgetAdminHandler: CallsWidgetAdminHandler,
    invoicesAndReceiptsWidgetAdminHandler: InvoicesAndReceiptsWidgetAdminHandler,
    relatedContactsAdminHandler: RelatedContactsAdminHandler,
    budgetVsActualWidgetAdminHandler: BudgetVsActualWidgetAdminHandler,
    headLeaseScheduleWidgetAdminHandler: HeadLeaseScheduleWidgetAdminHandlerService
  ) {
    this.map = new Map<WidgetTypeId, WidgetAdminHandler>();
    this.map.set('CashBalances', cashBalances);
    this.map.set('TenancyScheduleWidget', tenancySchedule);
    this.map.set('ArrearsChart', arrears);
    this.map.set('ArrearsTable', arrears);
    this.map.set('ContactUs', contactUs);
    this.map.set('DetailsWidget', defaultHandler);
    this.map.set('PropertyPicture', propertyPictures);
    this.map.set('DiaryWidget', diary);
    this.map.set('CreditorAccounts_MD', creditorAccount);
    this.map.set('CreditorAccounts_MFS', creditorAccount);
    this.map.set('ManagerDetails', managerDetails);
    this.map.set('InvoiceUpload', invoiceUpload);
    this.map.set('MfsCreditorDetails', creditorDetails);
    this.map.set('MfsSupplierDetailsWidget', defaultHandler);
    this.map.set('MojoCreditorDetails', creditorDetails);
    this.map.set('PaymentsToYou_MD', paymentsToYouWidgetAdminHandler);
    this.map.set('PaymentsToYou_MFS', paymentsToYouWidgetAdminHandler);
    this.map.set('MfsInvoiceStatus', invoiceStatusWidgetAdminHandler);
    this.map.set('MojoInvoiceStatus', invoiceStatusWidgetAdminHandler);
    this.map.set('MojoDocumentCentre', pmaDocumentCentre);
    this.map.set('MfsDocumentCentre', pmaDocumentCentre);
    this.map.set('MftDocumentCentre', pmaDocumentCentre);
    this.map.set('AdditionalInformationCreditor', additionalInformationWidgetAdminHandler);
    this.map.set('AdditionalInformationDebtor', additionalInformationWidgetAdminHandler);
    this.map.set('AdditionalInformationHeadLease', additionalInformationWidgetAdminHandler);
    this.map.set('AdditionalInformationLease', additionalInformationWidgetAdminHandler);
    this.map.set('AdditionalInformationProperty', additionalInformationWidgetAdminHandler);
    this.map.set('AdditionalInformationUnit', additionalInformationWidgetAdminHandler);
    this.map.set('AdditionalInformationClient', additionalInformationWidgetAdminHandler);
    this.map.set('AdditionalInformationLandlord', additionalInformationWidgetAdminHandler);
    this.map.set('MftUnitDetailsWidget', defaultHandler);
    this.map.set('MftTenantDetailsWidget', defaultHandler);
    this.map.set('MftLeaseDetailsWidget', defaultHandler);
    this.map.set('MftTenantParentDetailsWidget', defaultHandler);
    this.map.set('MojoTenantParentDetailsWidget', defaultHandler);
    this.map.set('NotificationRequestWidget', defaultHandler);
    this.map.set('NotificationWidget', defaultHandler);
    this.map.set('MftDebtorDetailsWidget', defaultHandler);
    this.map.set('ArrearsListingWidget', defaultHandler);
    this.map.set('ArrearsTenantListingWidget', defaultHandler);
    this.map.set('ItemsDueWidget', defaultHandler);
    this.map.set('DebtBalancesDueWidget', defaultHandler);
    this.map.set('MojoDebtorAccountHistory', debtorAccountHistoryHandler);
    this.map.set('MftDebtorAccountHistory', debtorAccountHistoryHandler);
    this.map.set('MciDebtorAccountHistory', debtorAccountHistoryHandler);
    this.map.set('NoticeBoard', defaultHandler);
    this.map.set('CallsWidget', callsWidgetAdminHandler);
    this.map.set('InvoicesAndReceiptsWidget', invoicesAndReceiptsWidgetAdminHandler);
    this.map.set('MojoInvoicesAndReceiptsWidget', invoicesAndReceiptsWidgetAdminHandler);
    this.map.set('MojoSupplierRelatedContactWidget', relatedContactsAdminHandler);
    this.map.set('MojoLandlordRelatedContactWidget', relatedContactsAdminHandler);
    this.map.set('MojoTenantRelatedContactWidget', relatedContactsAdminHandler);
    this.map.set('MojoClientRelatedContactWidget', relatedContactsAdminHandler);
    this.map.set('MfsSupplierRelatedContactWidget', relatedContactsAdminHandler);
    this.map.set('MftTenantRelatedContactWidget', relatedContactsAdminHandler);
    this.map.set('MciClientRelatedContactWidget', relatedContactsAdminHandler);
    this.map.set('MciClientDetailsWidget', defaultHandler);
    this.map.set('MojoClientDetailsWidget', defaultHandler);
    this.map.set('MojoBudgetVsActualWidget', budgetVsActualWidgetAdminHandler);
    this.map.set('MojoBudgetVsActualUnitWidget', budgetVsActualWidgetAdminHandler);
    this.map.set('MciBudgetVsActualWidget', budgetVsActualWidgetAdminHandler);
    this.map.set('MftBudgetVsActualUnitWidget', budgetVsActualWidgetAdminHandler);
    this.map.set('HeadLeaseScheduleWidget', headLeaseScheduleWidgetAdminHandler);
  }

  get(widgetTypeId: WidgetTypeId): WidgetAdminHandler {
    return this.map.get(widgetTypeId);
  }

  all(): Array<[WidgetTypeId, WidgetAdminHandler]> {
    return Array.from(this.map.entries());
  }

}
